import React, { useEffect } from 'react'
import Input from '../../common/Input'
import { get } from 'lodash'
import { phoneFormatter } from '../../common/util'
import { Comment, Error } from '../../common/Text'
import { checkConfirmEmail, checkEmail, checkPhone } from '../../common/validator'
import styled from 'styled-components'

const EmployeeContactContainer = styled.div`
  .telephone {
    margin-top: 20px;
    min-width:  180px;
  }
  .email{
    margin-top: 20px;
    min-width:  180px;
  }

  .notice {
    margin-top: 5px;
  }
`

export default function EmployeeContactForm({
                                                employee, submitError, error, editable,
                                                onErrorChange, onEmployeeChange, onCanSaveChange, ...props
                                              }) {


  const onFormValueChange = (key) => {
    return (value) => {
      const newForm = {
        ...employee,
        [key]: value
      }
      onEmployeeChange(newForm)
    }
  }

  useEffect(() => {
    if (employee) {
      const newError = {}
      newError.phoneNumber = checkPhone(employee.phoneNumber)
      newError.email = checkEmail(employee.email)
      newError.confirmEmail = employee.email && checkConfirmEmail(employee.email, employee.confirmEmail)
      onErrorChange(newError)
      if (!editable) {
        onCanSaveChange(true)
      } else {
        const inputEmailIsDefined = get(employee, 'email') && get(employee, 'confirmEmail')
        const inputEmailIsCorrect = !newError.email && !newError.confirmEmail
        const inputPhoneNumberIsCorrectIfDefined = !newError.phoneNumber
        onCanSaveChange(inputEmailIsDefined && inputEmailIsCorrect && inputPhoneNumberIsCorrectIfDefined)
      }
    }
  }, [employee])

  const handlerPaste = (e) => {
    e.preventDefault()
    e.nativeEvent.stopImmediatePropagation()
  }

  return (
    <EmployeeContactContainer>
      <Input direction="column"
             label="Téléphone"
             labelClassName="telephone"
             placeholder="Non renseigné"
             optional={ true }
             value={ get(employee, 'phoneNumber') }
             error={ error.phoneNumber }
             formatter={ phoneFormatter }
             validated={ get(employee, 'phoneNumber') && !error.phoneNumber }
             onValueChange={ onFormValueChange('phoneNumber') }
             disabled={ !editable }
      />
      <Comment className='notice'>
        L’objet des éventuels appels ne concernera que votre dossier Pimprenelle.
      </Comment>

      <Input direction="column"
             labelClassName="email"
             label="E-mail"
             placeholder="Adresse e-mail"
             required={ true }
             value={ get(employee, 'email') }
             error={ error.email }
             validated={ get(employee, 'email') && !error.email }
             onValueChange={ onFormValueChange('email') }
             disabled={ !editable }
      />

      {
        editable && <Input direction="column"
                           labelClassName="email"
                           label="Confirmer votre e-mail"
                           placeholder="Adresse e-mail"
                           required={ true }
                           value={ get(employee, 'confirmEmail') }
                           error={ error.confirmEmail }
                           validated={ get(employee, 'confirmEmail') && !error.confirmEmail }
                           onValueChange={ onFormValueChange('confirmEmail') }
                           onPaste={ handlerPaste }
        />
      }
      {
        editable && <Comment className='notice'>
          Votre adresse e-mail nous permettra de communiquer avec vous sur l’avancement de votre demande.
        </Comment>
      }
      { submitError && <Error>{ submitError }</Error> }
    </EmployeeContactContainer>
  )
}
